import React, { FC } from 'react';
import * as classes from './MapLocationInfo.module.scss';
import IconArrow from '../../../../../assets/icons/inline/arrow-up-right-blue.inline.svg';
import { GOOGLE_MAP_PLACES_URL } from '../../../../../constants/constants';
import Link from '../../../../Common/Link/Link';

interface Props {
  name: string;
  address: string;
  phone: string;
  buttonLink: string;
  buttonTitle: string;
  buttonText: string;
  latitude: number;
  longitude: number;
  linkToGMapsText?: string;
}

const MapLocationInfo: FC<Props> = ({
  name,
  address,
  phone,
  buttonLink,
  buttonTitle,
  buttonText,
  latitude,
  longitude,
  linkToGMapsText,
}) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.title}>
        {name}
        <div className={classes.linkToGoogleMaps}>
          <Link isTargetBlank isExternalLink path={`${GOOGLE_MAP_PLACES_URL}${latitude},${longitude}`}>
            {linkToGMapsText}
          </Link>
        </div>
      </div>
      <div className={classes.address}>{address}</div>
      <div className={classes.phone}>
        <a href={`tel:${phone}`}>{phone}</a>
      </div>
      <div className={'d-flex'}>
        <a href={buttonLink} title={buttonTitle}>
          <div className={classes.link}>
            {buttonText}
            <IconArrow />
          </div>
        </a>
      </div>
    </div>
  );
};

export default MapLocationInfo;
